import React, { Component } from 'react';
import * as Request from '../../service/data-info-chart/requestsUtil';
import '../../../node_modules/rc-rate/assets/index.css';
import view from '../../resources/images/estrategas/tools/view.svg';


class View extends Component {

  constructor(props) {
    super(props);
    this.viewReport = this.viewReport.bind(this);
  }

  viewReport() {
    Request.getFetch2(this.props.url)
      .then(url => {
        window.open(url);
      });
  }

  render() {
    return (
      <div className='quality-edit'>
        <img src={view} title="Ver" alt=" " onClick={this.viewReport}/>
      </div>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/components/buttons/view.js